<template>
<div class="row  " >
    <div style="display: block">
        <div :class="{'warning-icon':(!isMyUserAdmin)}" />
        <h3 class="">EMS Control</h3>
    </div>

    <div :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}" class="mt-4">
        <div class="col-1 mt-2 ">
            <h4> Mode: </h4>
        </div>
        <div class="col-4">
            <dxSelectBox
                :disabled="!isMyUserAdmin"
                :items="modeData"
                value-expr="name"
                display-expr="label"
                v-model:value="modeSelected"
                :on-value-changed="showPopupApplyChanges"
            />
        </div>
    </div>

    <div class="mt-4">
        <DxTabPanel 
            :items="screenList"
            :animation-enabled="false" 
            :swipe-enabled="false"
            v-model:selected-index="selectedScreen">
        </DxTabPanel>
    </div>
   
    <div class="px-4" >   
        <div v-if="selectedScreen==0" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}" class="col-6  mt-3" style="min-width:350px">
            <div class="dx-card p-2">
                <div  class="col mx-1" style="height:30px">
                    <DxButton
                        width="6rem"
                        heght="85%"
                        text="Apply"
                        type="normal"
                        @click="applyPriorityClick"
                    />
                </div>
              
                <div class="row box mx-1">
                    <div class="col-1  px-3 mt-4" >
                        <p style="transform: rotate(-90deg)">max</p>
                        <div class="dx-icon-sortup"></div>
                        <p style="transform: rotate(-90deg); margin-top: 2em">min</p>
                    </div>
                    <DxList
                        class="px-0 col"
                        :data-source="ControllerList"
                        :repaint-changes-only="true"
                        key-expr="id"
                        display-expr="id"
                        height="320"
                        item-delete-mode="toggle">
                        <DxItemDragging
                            :allow-reordering="isMyUserAdmin"
                            :move-item-on-drop="true"
                            :on-reorder="onDragStart"/>

                        <template #item ="{ data }">
                            <div v-if="data.enabled"  >{{ data.id }}</div>
                            <div v-else  style="color:#c1c1c1">{{ data.id }}</div>
                        </template>
                    </DxList>
                    
                </div>
                
            </div>
        </div>

        <div v-if="selectedScreen==1" :class="{'col':true, 'mt-3':true, 'disabled-overlay':(!['manual','external_dispatch'].includes(currentState)  || !isMyUserAdmin)}"  style="min-width:700px "  >
            <div class="row  dx-card p-2 ">
                <div class="col m-0 mx-1 p-0">  
                    <h5  style="height:30px; margin:0px" >Activated components</h5>
                    <div class="box">
                    <DxTreeList
                        id = "deviceTreeEnabled"
                        ref="deviceTreeEnabled"
                        :data-source="EnabledSignalsList"
                        :show-column-headers="false"
                        :show-borders="false"
                        :show-row-lines="false"
                        :show-column-line="false"
                        :show-selection-controls="true"
                        v-model:selected-row-keys="SelectedItems"
                        @selection-changed="onSelectionChanged"
                        key-expr="id"
                        parent-id-expr="parent_id"
                        height="320"
                        :root-value="-1"
                        >
                        <DxSelectionTree  
                            recursive="recursive"
                            mode="multiple" />
                        <DxFilterRow :visible="true"/>
                            
                        <DxColumnTree
                            data-field="text"
                            :allow-search="true"
                            />                     
                    </DxTreeList></div>
                </div>

                <div class="col align-self-center p-0" style="max-width:2rem" align="center">
                    <div class="row-1 " >
                    <DxButton
                        id="back"
                        icon="arrowright"
                        @click="SelectSignalClick()"
                    />
                    </div>
                    
                </div>

                <div class="col  m-0 mx-1 p-0">
                    <h5  style="height:30px; margin:0px">Selected components</h5>
                    <div class="box">
                        <DxDataGrid
                            :data-source="SelectedSignalsList"
                            :remote-operations="false"
                            :allow-column-reordering="true"
                            :row-alternation-enabled="true"
                            :show-borders="true"
                            width="100%"
                            height="290"
                            @content-ready="onContentReady"
                            :paging="{enabled:false}"
                        >
                            <DxEditingGrid
                                mode="cell"
                                :allow-updating="true"
                                :allow-deleting="true"
                                />
                            <DxColumn
                                :group-index="0"
                                data-field="asset"
                                caption=""
                                width="5px"
                                />
                            <DxColumn
                                :allow-editing="false"
                                data-field="text"
                                caption="Variable"
                                /> 
                            <DxColumn
                                data-field="value"
                                :allow-editing="true"
                                :calculate-cell-value="calculateSalesAmount"
                                /> 
                            <DxColumn type="buttons" width="40px">
                                <DxDGButton name="delete" /> 
                            </DxColumn>
                        </DxDataGrid>
                
                        <DxButton
                            id="sendBt"
                            text="Send commands"
                            type="success"
                            width="70%"
                            height="30px"
                            @click="SendCommandsClick()" />
                        <DxButton
                            id="sendBt"
                            text="Clear"
                            type="danger"
                            width="30%"
                            height="30px"
                            @click="clearCommandsClick()"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedScreen==2" :class="{'col':true, 'mt-3':true}" >
            <div class="paginacion m-0 pb-0">
                <ul class="m-0 pb-0">
                    <li v-for="(value) of array_years" :key="value"><a class="active" @click="changeYear(value)">{{ value }}</a></li>
                </ul>
            </div>
            
            <div style=" overflow-y: scroll;height: 500px" >
                <div style="position: sticky; top: 0; background: white; z-index: 10;">
                    <axisX :domain="[0,24]" height="35" width="900"/>
                </div>
                <div> <!---->
                    <RangeChart :data="srad_scheduler" height="25" maxElements="365" width="900" :hideAxisX="true"/>
                </div>
            </div>
            
        </div>
    </div>

    <DxPopup
        content-template="apply-changes"
        max-width="300px"
        max-height="100px"
        :show-title="false"
        :show-close-button="false"
        v-model:visible="isApplyChangesVisible"
        :hide-on-outside-click="true">
        <template #apply-changes>
            <p>The operating mode will change. </p>
            <div class="row">
                <div class="col-6">
                    <DxButton
                    text="Continue"
                    type="success"
                    width="100%"
                    @click="modeChanged"
                    /> 
                </div> 
                <div class="col-6">
                    <DxButton
                    text="Cancel"
                    type="danger"
                    width="100%"
                    @click="cancelApplyChanges"
                    />  
                </div>
            </div>
        </template>            
    </DxPopup>

</div>
</template>

<script>
import {ref, computed} from 'vue';
import DxList, { DxItemDragging } from 'devextreme-vue/list';
import DxButton from 'devextreme-vue/button';
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import ArrayStore from 'devextreme/data/array_store';
import RawDataService from '../services/RawDataServiceTemplate';
import notify from 'devextreme/ui/notify';
import DxTabPanel from 'devextreme-vue/tab-panel'
import { useStore } from 'vuex';
import {
  DxTreeList,
  DxSelection as DxSelectionTree,
  DxColumn as DxColumnTree,
  DxFilterRow,
} from 'devextreme-vue/tree-list';
import dxSelectBox from 'devextreme-vue/select-box'
import {
  DxDataGrid,
  DxColumn,
  DxButton as DxDGButton,
  DxEditing as DxEditingGrid,
} from 'devextreme-vue/data-grid';
import { DxPopup } from 'devextreme-vue/popup';

import RangeChart from './charts-d3/rangeBarChart.vue';
import axisX from './charts-d3/axisX.vue';

export default {
    components:{
        DxList,
        DxItemDragging,
        DxButton,
        DxTreeList,
        DxSelectionTree,
        DxColumnTree,
        DxFilterRow,
        DxDataGrid,
        DxColumn,
        DxDGButton,
        DxEditingGrid,
        DxPopup,
        dxSelectBox,
        DxTabPanel,
        RangeChart,
        axisX
    },
    data(){
    },
    setup() {
        // Validate permissions
        const store = useStore()
        const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
        const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
        //
        const modeData = ref([])
        const screenList = computed(()=>{
            const views= [
                { ctrId: 'CONTROLLERS', title:'Controller priority' },
                { ctrId: 'COMANDS', title: 'Manual Command ' }
                ]

            if (typeof modeData.value.find(md=>md.name.includes('_srad_')) != 'undefined') views.push({ ctrId: 'SRAD', title: 'SRAD' })

            return views
        })
        const stErrorCb = err => { notify(err.message, "error", 3000); }
        const controllerDataService = new RawDataService('controllers');
        const emsDataService = new RawDataService('masters/ems');

        const selectedScreen = ref(0);

        // Comfirm mode change
        const modeSelected = ref(null);
        const currentState = ref(null)
        const isApplyChangesVisible = ref(false);
        const modeChanged = ()=>{
            emsDataService.update(1,{mode:modeSelected.value})

            isApplyChangesVisible.value = false;
            currentState.value=modeSelected.value
        }

        const showPopupApplyChanges = (e) =>{
            if(e.previousValue!=null && modeSelected.value!=currentState.value)
                isApplyChangesVisible.value = true;
        }
        const cancelApplyChanges = async() =>{
            isApplyChangesVisible.value = false;
            modeSelected.value=currentState.value
          
        }


        // MANUAL
        const enfyoSignalsDataService = new RawDataService('masters/signals');
        const enfyoAssetsDataService = new RawDataService('masters/assets');
        const enfyoPointsDataService = new RawDataService('sunspec/config/enfyoPoints');

        const EnabledSignalsStore = new CustomStore({
            key: 'id',
            
            load: async() => {
                try{
                    let newDs = [];
                    let pointList = await enfyoPointsDataService.getAll();
                    let signalList = await enfyoSignalsDataService.getAll();
                    let assetList = await enfyoAssetsDataService.getAll();

                    for(const asset of assetList){
                        const assetSigs = signalList.filter(s => s.assetName==asset.name && s.access == 'RW');
                        if (assetSigs.length>0){
                            newDs.push({
                                id: 'asset_'+asset.name, type: 'asset',
                                text: asset.name, description: asset.desc,
                            })
        
                            newDs = [
                                ...newDs, 
                                ...assetSigs.map(sig => {
                                    const point = pointList.find(p=>p.enfyoSignal_id==sig.signalId)
                                    return {
                                    id: 'signal_'+asset.name+'_'+sig.name, type: 'signal',
                                    text: sig.name, 
                                    description: sig.label,
                                    value: sig.value,
                                    signalId:sig.signalId,
                                    parent_id: 'asset_'+asset.name,
                                    max: point?.max_value || 0,
                                    min: point?.min_value || 0,
                                } })
                            ]
                        }
                        
                    }

                    return newDs;
                }catch(err) { notify('error: '+err.message, 'error', 4000); }  
                
            }

        });
        const EnabledSignalsList = new DataSource({
            store: EnabledSignalsStore,
            paginate: false
        });


        const signalsArr = []
        const SelectedSignalsStore = new ArrayStore({
            key: 'id',
            data: signalsArr,
        })
        const SelectedSignalsList = new DataSource({
            store: SelectedSignalsStore,
            paginate: false
        });


        const SelectedItems=ref([]);
        let SelectedAllItems=[];
        const onSelectionChanged = ({ component }) => {
            SelectedAllItems = component.getSelectedRowsData('all');
           SelectedAllItems = SelectedAllItems.filter(s => s.type == 'signal')
        }
        const SelectSignalClick = async()=>{
            try{
                for (const assetobj of SelectedAllItems){
                    SelectedSignalsList.store().insert(
                        {
                            id: assetobj.id,
                            type: assetobj.type,
                            text: assetobj.text,
                            description: assetobj.description,
                            value: assetobj.value,
                            signalId: assetobj.signalId,
                            asset: assetobj.parent_id.slice(6),
                            max: assetobj.max || 0,
                            min: assetobj.min || 0,
                    
                    })
                }
                SelectedSignalsList.reload();
                SelectedAllItems=[];
                SelectedItems.value=[];
                
            }catch(error){ stErrorCb(error); }

        }

        const calculateSalesAmount = (rowData)=>{
            if (rowData.max==0 && rowData.min==0)return rowData.value

            if(rowData.value > rowData.max)rowData.value=rowData.max
            if(rowData.value < rowData.min)rowData.value=rowData.min
            return rowData.value
        }

        const SendCommandsClick =  () =>{
            const signalsDataService = new RawDataService('masters/signals');
            const commandsDataService = new RawDataService('masters/command');
            let commands={};
            SelectedSignalsStore._array.forEach(async sig =>{
                if (sig.value!=null && sig.value!=undefined){
                    // save last value
                    await signalsDataService.update(sig.signalId, {value: sig.value})
                    .then(
                        commands[sig.text]={
                            signalId: sig.signalId,
                            value: sig.value,
                        }
                    ).catch(stErrorCb);
                }
            })
            console.log(JSON.stringify(commands))
            // send command
            commandsDataService.create({message: JSON.stringify(commands)})
            .then(res=>{
                if(res.isOk) notify('Commands sent','success',3000)
                else  notify('An error occurred sending the commands','error',3000)
            })
        }

        const clearCommandsClick = () =>{
            SelectedSignalsStore._array=[]
            SelectedSignalsList.reload()
        }
        // AUTOMATIC
        /// Priority controllers
        const ControllerStore = new CustomStore({
            key: 'id',
            load: async() => {
                try{
                const newDs= [];
                const ConList = await controllerDataService.getAll()
                
                for(const con of ConList){
                    newDs.push({
                    id: con.name,
                    enabled: con.isEnabled,
                    description: con.description,
                    type: con.typecontroller,
                    priority:con.priority
                    })
                }
                newDs.sort((a,b)=>a.priority-b.priority);
          
                return newDs;
                }catch(err) { notify('error building assets tree: '+err.message, 'error', 4000); }  
                
            }, 

        });

        const ControllerList = new DataSource({
            store: ControllerStore,
            paginate: false,
            
        }); 

        const applyPriorityClick= async ()=>{
            try{
                let priorityIdx=100;
                for(const item of ControllerList._items){
                    await controllerDataService.update(item.id,{priority: priorityIdx})
                    priorityIdx++;
                }

                notify("Changes successfully applied", "success", 2000)
            }catch(error){
                stErrorCb(error);
            }
            
        }
        const onDragStart=(e)=>{
            let tasks =ControllerList._items;
            const toIndex = e.toIndex;
            const fromIndex = e.fromIndex;
            const data=tasks[fromIndex];
            tasks.splice(fromIndex, 1);
            tasks.splice(toIndex, 0, data);
        }

        const srad_scheduler = ref([ ])
        const array_years = ref ([])

        const currentYear = ref(new Date().getFullYear())
        
        // buttons start, stop, pause

        const startEmsClick = ()=>{console.log('start')}
        const stopEmsClick = ()=>{console.log('stop')}
        const pauseEmsClick = ()=>{console.log('pause')}

        
        const  loadApp = async ()=>{
           const emsModes = await emsDataService.getByKey('modes');
           const emsConf = await emsDataService.getAll();
           modeData.value = emsModes
           modeSelected.value = emsConf.mode
           currentState.value = modeSelected.value

           const schedulerData = await loadScheduler()
           const minYear = new Date(schedulerData.reduce((a,b)=>{ return b.time < a.time ? b: a }).time*1000).getFullYear()
           const maxYear = new Date(schedulerData.reduce((a,b)=>{ return b.time > a.time ? b: a }).time*1000).getFullYear()

           array_years.value=[]
           for (let i = minYear; i <= maxYear; i += 1) {array_years.value.push(i);}
        }
        loadApp()

        const loadScheduler = async ()=>{
           const schedulerData = await emsDataService.getByKey('modes/srad/scheduler');
           srad_scheduler.value=[]
           for( let value of schedulerData){
                if(value.isAvailable ){
                    const day = new Date(value.time*1000)
                    if(day.getFullYear()==currentYear.value){
                        const hour = new Date(value.time*1000).getHours()
                        srad_scheduler.value.push({
                            value:[hour, hour+1],
                            name: (day.getMonth()+1)+'/'+day.getDate()+'/'+ day.getFullYear()
                        })
                    }
                }
           }
           return schedulerData
        }

        const changeYear=(year)=>{
            currentYear.value=year;
            loadScheduler()
        }
        return {
            isMyUserAdmin,
            modeSelected,
            screenList,
            currentState,
            modeChanged,
            ControllerList,
            SelectedItems,
            onSelectionChanged,
            EnabledSignalsList,
            SelectedSignalsList,
            SelectedSignalsStore,
            SelectSignalClick,
            SendCommandsClick,
            clearCommandsClick,
            onDragStart,
            applyPriorityClick,
            modeData,
            selectedScreen,

            startEmsClick,
            stopEmsClick,
            pauseEmsClick,

            isApplyChangesVisible,
            showPopupApplyChanges,
            cancelApplyChanges,
            calculateSalesAmount,
            srad_scheduler,
            array_years,
            changeYear
        }
    },
   
}

</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.radiobutton-mod .dx-item-content{
  font-size: 1.3em;
  margin:0.5em;
}

.paginacion {
	margin:10px 0;
}

.paginacion ul {
	list-style:none;
	text-align: center;
}

.paginacion ul li {
	display:inline-block;
	margin-right:10px;
}

.paginacion ul li a {
	display:block;
	padding:10px 15px;
	color:#161616;
	text-decoration: none;
}

.paginacion ul li a:hover {
	background:#d5131638;
}

.paginacion ul li .active {
	font-weight:bold;
}


</style>